import styled from 'styled-components';

export const ItemList = styled.div`
  display: flex;
  padding: 0;
  flex-wrap: wrap;
  max-width: 84rem;
  justify-content: space-between;
  margin: 5rem auto 5rem auto;
`;
